import { useCallback } from 'react';
import { callGqlEndpoint, useGqlDataHook } from '@bymason/utils';

export interface AccountMetadata {
  accountMetadata: {
    devices: {
      total: number;
    };
    groups: {
      total: number;
    };
    projects: {
      total: number;
    } | null;
  };
}

export function useGetAccountMetadata(clientToken: string) {
  const handleGetData = useCallback(() => {
    return callGqlEndpoint<AccountMetadata>({
      clientToken,
      query: `
        {
          accountMetadata: dashboardMetadata {
            devices {
              total
            }
            groups {
              total
            }
            projects {
              total
            }
          }
        }
      `,
    });
  }, [clientToken]);

  return useGqlDataHook(handleGetData);
}
